<template>
  <p class="text-black-10 font-normal text-sm" test-id="paginationDetails">
    Showing {{ entryIndex }} to {{ endIndex }} of {{ totalCount }} entries
  </p>
</template>

<script>
export default {
  props: {
    pageSize: {
      // number of items displayed per page
      type: Number,
      required: true,
      default: 0
    },
    currentPage: {
      // the current page i.e page 1 or 2 or ...
      type: Number,
      required: true,
      default: 0
    },
    totalCount: {
      // total number of items in the array
      type: Number,
      required: true,
      default: 0
    }
  },
  computed: {
    entryIndex () {
      return this.pageSize * (this.currentPage - 1) + 1
    },
    endIndex () {
      if (this.totalCount > this.pageSize) {
        const end = this.currentPage * this.pageSize
        return end > this.totalCount ? this.totalCount : end
      } else {
        return this.totalCount
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
